module.exports = __webpack_public_path__ + "static/img/9.4442b23.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/2/1/zh/9.png
// module id = Vkww
// module chunks = 0